import * as yup from "yup";

// ASCII printable characters validation (space to tilde: 0x20-0x7E)
const asciiPrintableRegex = /^[ -~]*$/;

/**
 * Language codes for treatment plan protocol generation.
 * Uses ISO 639-1 two-letter language codes.
 */
export const LANGUAGE_OPTIONS = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "French",
    value: "fr",
  },
  {
    label: "Spanish",
    value: "es",
  },
  {
    label: "Arabic",
    value: "ar",
  },
] as const;

export const treatmentProtocolGenerationSchema = yup.object({
  language: yup
    .string()
    .oneOf(LANGUAGE_OPTIONS.map((option) => option.value))
    .default("en"),
  budgetConstraints: yup
    .string()
    .max(250, "Budget constraints must be less than 250 characters")
    .test(
      "is-ascii-printable",
      "Budget constraints must contain only ASCII printable characters",
      (value) => !value || asciiPrintableRegex.test(value)
    )
    .optional(),
  exclusions: yup
    .string()
    .max(2000, "Exclusions must be less than 2000 characters")
    .test(
      "is-ascii-printable",
      "Exclusions must contain only ASCII printable characters",
      (value) => !value || asciiPrintableRegex.test(value)
    )
    .optional(),
  clinicalFocus: yup
    .string()
    .max(2000, "Clinical focus must be less than 2000 characters")
    .test(
      "is-ascii-printable",
      "Clinical focus must contain only ASCII printable characters",
      (value) => !value || asciiPrintableRegex.test(value)
    )
    .optional(),
});

export type TreatmentProtocolGenerationFormData = yup.InferType<
  typeof treatmentProtocolGenerationSchema
>;
